import {createApp} from "vue";

/**
 * @param component
 * @deprecated Si consiglia di usare il metodo component_instance
 * @returns {{app: App<Element>, mount: *}}
 */
export function createPluginInstance(component) {
  const pluginInstanceEl = document.createElement('div')
  const pluginInstance = createApp(component, {});
  const pluginInstanceMount = pluginInstance.mount(pluginInstanceEl)

  return {
    app: pluginInstance,
    mount: pluginInstanceMount
  }
}

/**
 * Si occupa di creare un instanza dinamica partendo dal componente passato
 * lo smonta non appena finito di eseguire le operazioni passate
 * @param component
 * @param callback
 * @returns {Promise<void>}
 */
export async function component_instance(component, callback) {
  const instanceEL = document.createElement('div')
  const instance = createApp(component, {});
  const instanceMounted = instance.mount(instanceEL)
  instanceMounted.show();

  await callback();

  setTimeout(() => {
    instanceMounted.hide();
    instance.unmount();
  }, 200)
}
